import {
  ObservabilityToolType,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'
import { OBSERVABILITY_TOOL_DISPLAY_NAME } from 'utils/status-checks/status-checks-utils'

export type TeamExternalIntegrationRow = TeamExternalIntegration & {
  displayName: string
}

/*
 * These auths have specific displayName logic,
 * they need further distinguishing ids (domain, etc) or something else
 */
const TYPE_TO_DISPLAY_MAP: Record<
  string,
  (savedIntegration: TeamExternalIntegration) => string
> = {
  [ObservabilityToolType.AWS]: (savedIntegration: TeamExternalIntegration) =>
    `${
      OBSERVABILITY_TOOL_DISPLAY_NAME[ObservabilityToolType.AWS]
    } (Account ID: ${savedIntegration.domain})`,
  [ObservabilityToolType.AZURE]: (savedIntegration: TeamExternalIntegration) =>
    `${
      OBSERVABILITY_TOOL_DISPLAY_NAME[ObservabilityToolType.AZURE]
    } (Subscription ID: ${savedIntegration.domain})`,
  [ObservabilityToolType.GCP]: (savedIntegration: TeamExternalIntegration) =>
    `${
      OBSERVABILITY_TOOL_DISPLAY_NAME[ObservabilityToolType.GCP]
    } (Project ID: ${savedIntegration.domain})`,
  [ObservabilityToolType.GRAFANA]: () =>
    OBSERVABILITY_TOOL_DISPLAY_NAME[ObservabilityToolType.GRAFANA]
}

export function getTeamExternalIntegrationRow(
  savedIntegration: TeamExternalIntegration
): TeamExternalIntegrationRow {
  const getDisplayName = savedIntegration.observabilityToolType
    ? TYPE_TO_DISPLAY_MAP[savedIntegration.observabilityToolType]
    : undefined

  return {
    ...savedIntegration,
    displayName: getDisplayName?.(savedIntegration) ?? savedIntegration.name
  }
}

export function getIsThirdPartyIntegrationEditable(
  integration: TeamExternalIntegration
) {
  return integration.observabilityToolType === ObservabilityToolType.AWS
}
